"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMagentoErrorTranslationKey = exports.subscriptionEmailValidation = exports.newEmailValidation = exports.newPostalOrZipCodeValidation = exports.newPhoneNumberValidation = exports.passwordConfirmationValidation = exports.newPasswordValidation = void 0;
const formValidationHelper_1 = require("./formValidationHelper");
const inputErrorTranslations_1 = require("./inputErrorTranslations");
const newPasswordValidation = (currentLocale) => ({
    isLongEnoughPassword: (password) => (0, formValidationHelper_1.isLongEnoughPassword)(password) || inputErrorTranslations_1.translations[currentLocale].passwordMinLength,
    isValidPassword: (password) => (0, formValidationHelper_1.isValidPassword)(password) || inputErrorTranslations_1.translations[currentLocale].passwordRequirements,
});
exports.newPasswordValidation = newPasswordValidation;
const passwordConfirmationValidation = (currentLocale, currentPassword) => ({
    noMismatch: (confirmationPassword) => confirmationPassword === currentPassword || inputErrorTranslations_1.translations[currentLocale].passwordMismatch,
});
exports.passwordConfirmationValidation = passwordConfirmationValidation;
const newPhoneNumberValidation = (currentLocale) => ({
    isValidPhoneNumber: (phoneNumber) => (0, formValidationHelper_1.isValidPhoneNumber)(phoneNumber) || inputErrorTranslations_1.translations[currentLocale].wrongPhoneNumberFormat,
});
exports.newPhoneNumberValidation = newPhoneNumberValidation;
const newPostalOrZipCodeValidation = (currentLocale, countryCode) => ({
    isValidPostalOrZipCode: (postalOrZipCode) => (0, formValidationHelper_1.isValidPostalOrZipCode)(postalOrZipCode, countryCode) ||
        (countryCode === "US"
            ? inputErrorTranslations_1.translations[currentLocale].wrongZipCodeFormat
            : inputErrorTranslations_1.translations[currentLocale].wrongPostalCodeFormat),
});
exports.newPostalOrZipCodeValidation = newPostalOrZipCodeValidation;
const newEmailValidation = (currentLocale) => ({
    isValidEmail: (email) => (0, formValidationHelper_1.isValidEmail)(email) || inputErrorTranslations_1.translations[currentLocale].wrongEmailFormat,
});
exports.newEmailValidation = newEmailValidation;
const subscriptionEmailValidation = (currentLocale) => ({
    isValidEmail: (email) => email == "" || (0, formValidationHelper_1.isValidEmail)(email) || inputErrorTranslations_1.translations[currentLocale].wrongEmailFormat,
});
exports.subscriptionEmailValidation = subscriptionEmailValidation;
const getMagentoErrorTranslationKey = (currentLocale, errorMessage) => {
    switch (errorMessage) {
        case "A customer with the same email address already exists in an associated website.":
            return inputErrorTranslations_1.translations[currentLocale].magento.emailAlreadyTaken;
        case "The account sign-in was incorrect or your account is disabled temporarily. Please wait and try again later.":
            return inputErrorTranslations_1.translations[currentLocale].magento.invalidCredentials;
        default:
            return inputErrorTranslations_1.translations[currentLocale].defaultFormError;
    }
};
exports.getMagentoErrorTranslationKey = getMagentoErrorTranslationKey;
//# sourceMappingURL=reactHookFormValidationHelper.js.map